<template>
    <div class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

        <!-- Modal -->
        <div class="bg-white max-w-3xl overflow-hidden rounded-2xl shadow-2xl w-full">
            <!-- Header -->
            <div class="bg-indigo-100  border-b border-indigo-200 px-6 py-5">
                <div class="flex items-center gap-3">
                    <div class="bg-indigo-300 flex h-12 items-center justify-center rounded-full w-12">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" 
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                            class="h-6 text-indigo-600 w-6" aria-hidden="true">
                            <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                            <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                        </svg>
                    </div>
                    <div class="flex flex-col items-start justify-between">
                        <h3 class="text-gray-900 font-bold mb-1">Stay Informed</h3>
                        <p class="text-gray-700">Enter your details and we'll notify you when new values are released.</p>
                    </div>
                </div>
            </div>

            <!-- Body -->
            <div class="p-6">

                <div class="gap-4 grid grid-cols-2 mb-10">
                    <!-- First Name -->
                    <div>
                        <label class="block font-semibold mb-2 text-gray-700 text-left text-sm">First Name</label>

                        <div class="relative">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" 
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                                stroke-linejoin="round" 
                                class="absolute h-5 left-3 text-gray-400 top-1.5 w-5" aria-hidden="true">
                                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                            <input v-model="form.first_name"  type="text" data-slot="input" 
                            class="border border-gray-200 flex focus:border-indigo-600 focus:ring-2 focus:ring-indigo-600 h-9 md:text-sm min-w-0 outline-none pl-10 px-3 py-3 rounded-md text-base w-full"
                             placeholder="Enter your first name">
                        </div>
                        <p v-if="errors.first_name" class="text-left text-xs mt-1 text-red-600">
                            {{ errors.first_name }}
                        </p>
                    </div>

                    <!-- Last Name -->
                    <div>
                        <label class="block font-semibold mb-2 text-gray-700 text-left text-sm">Last Name</label>

                        <div class="relative">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" 
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                                stroke-linejoin="round" 
                                class="absolute h-5 left-3 text-gray-400 top-1.5 w-5" aria-hidden="true">
                                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                            <input v-model="form.last_name"  type="text" data-slot="input" 
                            class="border border-gray-200 flex focus:border-indigo-600 focus:ring-2 focus:ring-indigo-600 h-9 md:text-sm min-w-0 outline-none pl-10 px-3 py-3 rounded-md text-base w-full"
                             placeholder="Enter your last name">
                        </div>
                        <p v-if="errors.last_name" class="text-left text-xs mt-1 text-red-600">
                            {{ errors.last_name }}
                        </p>
                    </div>
                
                    <!-- Email -->
                    <div>
                        <label class="block font-semibold mb-2 text-gray-700 text-left text-sm">Email</label>

                        <div class="relative">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                                class="absolute h-5 left-3 text-gray-400 top-1.5 w-5" aria-hidden="true">
                                <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                            </svg>
                            <input v-model="form.email"  type="text" data-slot="input" 
                            class="border border-gray-200 flex focus:border-indigo-600 focus:ring-2 focus:ring-indigo-600 h-9 md:text-sm min-w-0 outline-none pl-10 px-3 py-3 rounded-md text-base w-full"
                             placeholder="Enter your email">
                        </div>
                        <p v-if="errors.email" class="text-left text-xs mt-1 text-red-600">
                            {{ errors.email }}
                        </p>
                    </div>

                    <!-- Phone -->
                    <div>
                        <label class="block font-semibold mb-2 text-gray-700 text-left text-sm">Phone Number</label>

                        <div class="relative">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                            class="absolute h-5 left-3 text-gray-400 top-1.5 w-5" 
                            aria-hidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>
                            </svg>
                            <input type="tel" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" v-model="form.phone" 
                            class="border border-gray-200 flex focus:border-indigo-600 focus:ring-2 focus:ring-indigo-600 h-9 md:text-sm min-w-0 outline-none pl-10 px-3 py-3 rounded-md text-base w-full"
                             placeholder="Enter your phone">
                        </div>
                    </div>
                </div>
                
                <!-- Actions -->
                <div class="flex flex-col gap-3 justify-end sm:flex-row">
                    <button class="rounded-md border px-4 py-2 h-9 text-sm " @click="$emit('close')">
                        Cancel
                    </button>

                    <button class="rounded-md bg-indigo-600 px-4 py-2 h-9 text-sm font-semibold text-white hover:bg-indigo-700"
                        @click="submit">
                        Confirm
                    </button>
                </div>    
            </div>

        </div>
    </div>
</template>

<script>
export default {
    emits: ['submitted', 'close'],

    data() {
        return {
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
            },
            errors: {},
        };
    },

    methods: {
        submit() {
            this.errors = {};

            if (!this.form.first_name) {
                this.errors.first_name = 'First name is required';
            }

            if (!this.form.last_name) {
                this.errors.last_name = 'Last name is required';
            }

            if (!this.form.email) {
                this.errors.email = 'Email is required';
            } else if (!this.validEmail(this.form.email)) {
                this.errors.email = 'Enter a valid email address';
            }

            if (Object.keys(this.errors).length) return;

            this.$emit('submitted', this.form);
        },

        validEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },

        inputClass(field) {
            return [
                'input',
                this.errors[field]
                    ? 'border-red-500 focus:ring-red-500'
                    : 'border-gray-300 focus:ring-indigo-500',
            ];
        },
    },
};
</script>